<template>
  <div class="Checkbox answerarea-item fontsize-16" :id="questionitem.innerid">
    <div class="topic-types">
        <p class="name" v-if="!isMaterialsItem"><span>{{questionitem.questionindex}}.</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="name" v-else><span>{{questioninfo.questionindex}}.{{questionitem.questionindex}}</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="title" v-html="questionitem.subject"></p>

        <div class="option-list">
          <el-checkbox-group v-model="questionitem.uselanswer">
            <div class="option-item" v-for="(options, index) in questionitem.optionslist" :key="index">
                <el-checkbox :label="options.optionsvalue" :disabled="examstatus == 1">
                    
                    <template v-if="examstatus == 1 || isshow == 1">
                        <i class="el-icon-check" v-if="options.isrightanswer == 1 && justAnswer(questionitem.uselanswer, questionitem.finalanswer, options.optionsvalue)"></i>
                        <i class="el-icon-close" v-else-if="inputContent(options.optionsvalue, questionitem.uselanswer) || justAnswer(questionitem.uselanswer, questionitem.finalanswer) && inputContent(options.optionsvalue, questionitem.uselanswer)"></i>
                        <i class="el-icon-view"  v-else style="visibility:hidden"></i>
                    </template>
                    <template v-else>
                        <i class="el-icon-view" style="visibility:hidden"></i>
                        <!-- end 占位用图标 -->
                    </template>
                  <span class="option-icon">
                    


                    {{options.optionsvalue}}.</span><span class="option-text" v-html="options.optionsinfo"></span>
                </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <div class="topic-types answer" v-if="examstatus == 1 || isshow == 1">
        <p>
          <span>本题得分：</span>
          <span class="fraction">{{questionitem.userscore}}分</span>
        </p>
        <p>
          <span>正确答案：</span>
          <span>{{questionitem.finalanswer}}</span>
        </p>
        <p>
          <span>答案解析：</span>
          <span v-html="questionitem.quesanalysis"></span>
        </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: ['questionitem', 'examstatus', 'isshow', 'isMaterialsItem', 'questioninfo'], // 试题列表 试卷提交状态 是否显示正确答案
  data () { 
    return {
    }
  },
  mounted () {
    //  console.log('this.questionitem.uselanswer',this.questionitem)
    this.$nextTick(() => {
        // 未提交答案情况下 初始化多选答案为数组类型 如果存在数据则进行拆分
        this.init()
    })
  },
  updated() {
    // this.init()
  },
  methods: {
    init() {  // 初始化多选题
        if (this.questionitem.uselanswer.length > 0 || this.examstatus == 1) {
           if (typeof this.questionitem.uselanswer !== 'object') {
             this.questionitem.uselanswer = this.questionitem.uselanswer.split(',')
           }
         } else {
           this.questionitem.uselanswer = []
         }
    },
    justAnswer(checkAnswer, finalanswer, optionsvalue) {  // 答案判断  选中答案 正确答案
    if (checkAnswer == optionsvalue) {
      return true
    }
      for (let i = 0; i < checkAnswer.length; i++) {

        for (let j = 0; j < finalanswer.length; j++) {

          if (finalanswer[j] == optionsvalue) {
            return true
          } 
          
          if (checkAnswer[i] == finalanswer[j]) {
            return true
          }
        }
      }
      return false
      // console.log(answer, checkAnswer)
    },
    inputContent(optionsvalue, uselanswer) {  // 判断改元素是否被选
      for (let i = 0; i < uselanswer.length; i++) {
        if (uselanswer[i] == optionsvalue) {
          return true
        }
      }
      return false
    }
  },
  filters: {},
  watch: {
    questionitemData() {
      // 未提交答案情况下 初始化多选答案为数组类型 如果存在数据则进行拆分
      this.init()
    }
  },
  computed: {
    questionitemData() {
      return this.questionitem
    }
  },
  components: {
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.Checkbox {
  .el-checkbox .el-checkbox__label {
      width: calc(100% - 30px) !important;
      float: right;
  }
}
</style>